// Update swym wishlist button in the main product form
document.addEventListener("variant:changed", function (event) {
  const form = event.target;
  const wishlistBtn = form.querySelector(".wishlist-btn");

  if (wishlistBtn) {
    if (!window.SwymCallbacks) return;

    window.SwymCallbacks[0]();
  }
});

// Footer menu accordions on mobile
const footerAccordionTriggers = document.querySelectorAll(
  ".js-accordion-trigger"
);
footerAccordionTriggers.forEach((trigger) => {
  trigger.addEventListener("click", function () {
    this.closest(".footer__item").classList.toggle("is-open");
  });
});

// Back In Stock - set cookie and reveal product recommendations on successful signup
(() => {
  function getSubmittedProducts() {
    const match = document.cookie
      .split(";")
      .find((c) => c.trim().startsWith("bis_products="));
    return match ? match.trim().slice("bis_products=".length).split(",") : [];
  }

  function saveSubmittedProduct(productId) {
    const products = getSubmittedProducts();
    if (!products.includes(productId)) products.push(productId);
    const expires = new Date();
    expires.setFullYear(expires.getFullYear() + 1);
    document.cookie = `bis_products=${products.join(
      ","
    )}; expires=${expires.toUTCString()}; path=/`;
  }

  function revealIfSubmitted() {
    document.querySelectorAll("[data-bis-gated]").forEach((el) => {
      const productId = el.getAttribute("data-bis-product-id");
      if (getSubmittedProducts().includes(productId)) {
        el.removeAttribute("data-bis-gated");
      }
    });
  }

  document.addEventListener("DOMContentLoaded", revealIfSubmitted);

  // Watch for the JSONP <script> tag the BIS app injects on form submit
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (
          node.nodeName === "SCRIPT" &&
          node.src?.includes("bis/signups/create")
        ) {
          node.addEventListener("load", () => {
            const url = new URL(node.src);
            const productId = url.searchParams.get("notification[product_no]");
            if (productId) saveSubmittedProduct(productId);
            revealIfSubmitted();
          });
        }
      }
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
